<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <div class="row row-space-between row-space-top">
                        <div class="col-size-auto">
                            <h2 class="subtitle">Beskatningsgrundlag</h2>
                        </div>
                        <div class="col-size-auto">
                            <a :href="priceListLink"
                               class="button has-icon"
                               :target="priceListLinkTarget"
                               v-if="priceListLink">
                                Hent pdf prisliste
                                <svg width="18"
                                     height="18"
                                     class="icon icon-md">
                                    <use href="/ui/icons/custom-sprite.svg#feather-download"></use>
                                </svg>
                            </a>
                            <a v-if="excelButtonVisible"
                               :href="downloadLink"
                               class="button has-icon">
                                Hent excel prisliste
                                <svg width="18"
                                     height="18"
                                     class="icon icon-md">
                                    <use href="/ui/icons/custom-sprite.svg#feather-download"></use>
                                </svg>
                            </a>
                        </div>
                    </div>

                    <model-details-tax-base-overview-table v-for="group in tableGroups"
                                                           :key="group.type"
                                                           :table-data="group.cars"
                                                           :table-type="group.type"
                                                           :overview-terms-and-conditions-text="overviewTermsAndConditionsText"
                                                           :initial-sort-key="''">

                    </model-details-tax-base-overview-table>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
import _ from 'lodash';
import ModelDetailsTaxBaseOverviewTable from './ModelDetailsTaxBaseOverviewTable.vue';

export default {
    name: 'model-details-tax-base-overview',
    props: {
        tableData: {
            type: Array,
            default: undefined
        },
        priceListLink: {
            type: String,
            default: undefined
        },
        priceListLinkTarget: {
            type: String,
            default: undefined
        },
        excelLink: {
            type: String,
            default: undefined
        },
        excelButtonVisible: {
            type: Boolean,
            default: undefined
        },
        modelId: {
            type: String,
            default: undefined
        },
        overviewTermsAndConditionsText: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
        }
    },
    computed: {
        downloadLink: function () {
            return `${this.$props.excelLink}?ids=${this.$props.modelId}`;
        },
        tableTypes: function () {
            if (this.$props.tableData) {
                let carTable = this.$props.tableData;
                let propellants = carTable.map(car => car.propellant);
                let propellantTypes = _.uniqBy(propellants);

                return propellantTypes;
            }

            return undefined;
        },
        tableGroups: function () {
            if (this.$props.tableData) {
                let carTable = this.$props.tableData;
                let carTableGroups = _.groupBy(carTable, car => car.propellant);

                let resultArray = [];
                this.tableTypes.forEach(function (propellantType) {
                    resultArray.push({ type: propellantType, cars: carTableGroups[propellantType] });
                });

                return resultArray;
            }

            return undefined;
        }
    },
    components: {
        ModelDetailsTaxBaseOverviewTable
    }
}
</script>